const renderFixStrong = (data) => {
  // make !!strong!!
  let dataMix = data && JSON.parse(data) ? { ...JSON.parse(data) } : null;
  // lấy giá trị trong strong
  if (dataMix?.blocks && dataMix?.blocks.length > 0 && Array.isArray(dataMix?.blocks)) {
    // get value into strong regex
    const pattern = /!!strong!!(.*?)!!strong!!/g;
    dataMix["blocks"] = (dataMix?.blocks || []).map((r, index) => {
      const indicesAndLengths = [];
      let match;
      while ((match = pattern.exec(r?.text)) !== null) {
        indicesAndLengths.push({
          offset: match.index,
          length: (match[1] && match[1].length) || 0,
          style: "BOLD",
        });
      }
      if (r?.text.includes("!!strong!!")) {
        return {
          ...r,
          text: r?.text.replace(/!!strong!!/g, "").trim(),
          inlineStyleRanges: indicesAndLengths,
        };
      } else {
        return {
          ...r,
          text: (r?.text && r.text.trim()) || "",
        };
      }
    });
    // xóa khoảng trống nếu bị quá nhiều
    let emptyFlag = false;
    let result = [];
    for (let i = 0; i < dataMix["blocks"].length; i++) {
      if (
        dataMix["blocks"][i]["text"] === "" ||
        dataMix["blocks"][i]["text"].replaceAll(" ", "") === ""
      ) {
        if (!emptyFlag) {
          result.push(dataMix["blocks"][i]);
          emptyFlag = true;
        }
      } else {
        result.push(dataMix["blocks"][i]);
        emptyFlag = false;
      }
    }
    // Remove empty list-item blocks (equivalent to PHP: remove <li> with only whitespace/<br/>)
    result = result.filter((block) => {
      const isListItem = block.type === "unordered-list-item" || block.type === "ordered-list-item";
      const isEmpty = !block.text || block.text.replaceAll(" ", "") === "";
      return !(isListItem && isEmpty);
    });

    // Ensure section-level headers have empty spacer blocks before AND
    // after them. Two header shapes qualify:
    //  - Main section headers: BOLD + UNDERLINE (e.g. ASSESSMENT)
    //  - Sub-headers: BOLD + ITALIC, rendered as <em><strong>…</strong></em>
    //    (e.g. therapy names like "Antiplatelet Therapy")
    // Saved templates from the DB sometimes lack spacers (e.g. MEDICATIONS
    // text stored directly in text13 with ALLERGIES header immediately
    // after, or header content starting right after the header with no gap).
    if (result && result.length > 0) {
      const hasStyle = (block, style) =>
        (block?.inlineStyleRanges || []).some((s) => s.style === style);
      const isSectionHeader = (block) =>
        block?.text?.length > 0 && hasStyle(block, "BOLD") && hasStyle(block, "UNDERLINE");
      const isSubHeader = (block) =>
        block?.text?.length > 0 && hasStyle(block, "BOLD") && hasStyle(block, "ITALIC");

      let spaced = [];
      for (let i = 0; i < result.length; i++) {
        const block = result[i];
        const needsSpacing = isSectionHeader(block) || isSubHeader(block);

        // Spacer BEFORE
        if (needsSpacing && spaced.length > 0) {
          const prev = spaced[spaced.length - 1];
          const prevIsEmpty = !prev?.text || prev.text.replaceAll(" ", "") === "";
          if (!prevIsEmpty) {
            spaced.push({
              key: `spacer-before-${block.key}`,
              text: "",
              type: "unstyled",
              depth: 0,
              inlineStyleRanges: [],
              entityRanges: [],
              data: {},
            });
          }
        }
        spaced.push(block);

        // Spacer AFTER
        if (needsSpacing && i < result.length - 1) {
          const next = result[i + 1];
          const nextIsEmpty = !next?.text || next.text.replaceAll(" ", "") === "";
          if (!nextIsEmpty) {
            spaced.push({
              key: `spacer-after-${block.key}`,
              text: "",
              type: "unstyled",
              depth: 0,
              inlineStyleRanges: [],
              entityRanges: [],
              data: {},
            });
          }
        }
      }
      result = spaced;
    }

    if (result && result.length > 0) {
      dataMix["blocks"] = result;
    }
  }
  return dataMix;
};

export default renderFixStrong;
